module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Db-Fb-Gc-Hb 后背.f601b0d3.png";